import ACTIONS from "./actions";

export const initialState = {
  status: {
    isLoading: true,
    isError: false,
    data: [],
  },
};

function logListReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.FETCH_LOG_LIST_INIT: {
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    }

    case ACTIONS.FETCH_LOG_LIST_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isError: false,
        data: action.payload,
      };
    }

    case ACTIONS.FETCH_LOG_LIST_FAILURE: {
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    }

    default:
      return state;
  }
}

export default logListReducer;
